export { ContractDetailsPage as default } from './contract-details-page'
